require('../../modules/es.array.iterator');

require('../../modules/es.object.to-string');

require('../../modules/es.string.iterator');

require('../../modules/es.symbol.iterator');

var WrappedWellKnownSymbolModule = require('../../internals/well-known-symbol-wrapped');

module.exports = WrappedWellKnownSymbolModule.f('iterator');